
import React, { Suspense, useState, useEffect, useRef } from "react";
import ReactDatePicker from "react-datepicker";
import Drawer from 'react-modern-drawer';
import DatePickerRange from "../../PeriodSelection/DatePickerRange";
import { format } from "date-fns";
import Modal from "react-responsive-modal";
import { EditSongDetail } from "./editSongDetail";
import { EditSongAdditionalDetail } from "./editSongAdditionalDetail";
import { EditSongAlternativeTitles } from "./editSongAlternativeTitles";
import { EditSongPerformingArtist } from "./editSongPerformingArtist";
import { EditSongRecordingDetails } from "./editSongRecordingDetails";
import { EditSongWorkOrigin } from "./editSongWorkOrigin";
import { EditSongVersionsExcerpts } from "./editSongVersionsExcerpts";

export default function NewSongs(param: any) {

    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => {
        setIsOpen(!isOpen)
    }

    const [showtab, setShowTab] = useState(1);
    const [showSubtab, setShowSubTab] = useState(1);

    const dateSelection = (e: any) => {
        if (e !== null) {

            if (e[0] !== null) {
                console.log(format(new Date(e[0]), 'yyyyMMdd'))
            }

            if (e[1] !== null) {
                console.log(format(new Date(e[1]), 'yyyyMMdd'))
            }
        }
    }

    return (
        <>
            <button className='icon-btn edit pull-right ml' onClick={() => { setIsOpen(!isOpen) }}> Add New Songs</button>

            <Modal open={isOpen} onClose={toggleDrawer} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} classNames={{ overlay: '', modal: 'ws-9 paddingCenterBox bgTransparent' }}>

                <div className="box ws-12 landing">

                    <div className="box-header-main well ws-12">  <h2>Song Details</h2>  </div>

                    <ul className="nav nav-tabs">
                        <li className={showtab === 1 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(1), setShowSubTab(1))}><a >Song Details</a></li>
                        <li className={showtab === 2 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(2), setShowSubTab(2))}><a >Song Additional Details</a></li>
                        <li className={showtab === 3 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(3), setShowSubTab(3))}><a >Alternative Titles</a></li>
                        <li className={showtab === 4 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(4), setShowSubTab(4))}><a >Performing Artist</a></li>
                        <li className={showtab === 5 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(5), setShowSubTab(5))}><a >Recording Details</a></li>
                        <li className={showtab === 6 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(6), setShowSubTab(6))}><a >Work Origin</a></li>
                        <li className={showtab === 7 ? "icon-btn info fill btn-l" : "icon-btn edit btn-l"} onClick={() => (setShowTab(7), setShowSubTab(7))}><a >Versions andExcerpts</a></li>
                    </ul>

                    <div className="box-content ws-12">

                        {showtab === 1 && <EditSongDetail />}
                        {showtab === 2 && <EditSongAdditionalDetail />}
                        {showtab === 3 && <EditSongAlternativeTitles />}
                        {showtab === 4 && <EditSongPerformingArtist />}
                        {showtab === 5 && <EditSongRecordingDetails />}
                        {showtab === 6 && <EditSongWorkOrigin />}
                        {showtab === 7 && <EditSongVersionsExcerpts />}

                    </div>

                    <div className="box-footer mb mr">
                        <button className="icon-btn edit btn-sm pull-right width120 height35" ><i className="fa fa-save"></i> reset</button>
                        <button className="icon-btn delete btn-sm pull-right width120 height35" onClick={() => setIsOpen(false)}><i className="fa fa-close"></i> Close</button>
                        <button className="icon-btn edit btn-sm pull-right width120 height35" onClick={() => setIsOpen(false)}><i className="fa fa-close"></i> Save</button>
                    </div>
                </div>
            </Modal>

        </>
    )
}